import Api from '../Base'

class PostShelfArtifact extends Api {
  requestUrl = `/api/shelfArtifact`

  method = 'POST'
}

export default PostShelfArtifact
